import React from "react";
import { Box, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import I18nText from "../../elements/I18nText";

const useStyles = makeStyles(theme => ({
  emptyState: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: theme.spacing(8, 2),
    minHeight: 400,
    textAlign: "center"
  },
  emptyIcon: {
    width: 120,
    height: 120,
    marginBottom: theme.spacing(3),
    opacity: 0.3,
    color: theme.palette.text.secondary
  },
  emptyTitle: {
    marginBottom: theme.spacing(1),
    fontWeight: 600,
    color: theme.palette.text.primary
  },
  emptyDescription: {
    maxWidth: 400,
    color: theme.palette.text.secondary,
    lineHeight: 1.6
  }
}));

const EmptyState = React.memo(({ hasFilters }) => {
  const classes = useStyles();

  return (
    <Box className={classes.emptyState}>
      <svg
        className={classes.emptyIcon}
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.5}
          d="M9 3v2m6-2v2M9 19v2m6-2v2M5 9H3m2 6H3m18-6h-2m2 6h-2M7 19h10a2 2 0 002-2V7a2 2 0 00-2-2H7a2 2 0 00-2 2v10a2 2 0 002 2zM9 9h6v6H9V9z"
        />
      </svg>

      <Typography variant="h5" className={classes.emptyTitle}>
        <I18nText>
          {hasFilters
            ? "devices.list.table.noDevicesFound.filterTitle"
            : "devices.list.table.noDevicesFound.title"}
        </I18nText>
      </Typography>

      <Typography variant="body1" className={classes.emptyDescription}>
        <I18nText>
          {hasFilters
            ? "devices.list.table.noDevicesFound.filterMessage"
            : "devices.list.table.noDevicesFound.message"}
        </I18nText>
      </Typography>
    </Box>
  );
});
export default EmptyState;
